export function getFullName(user) {
    return user ? "".concat(user.firstName, " ").concat(user.lastName) : 'Deleted User';
}
export function getInitials(user) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return user ? "".concat((_d = (_c = (_a = user.firstName) === null || _a === void 0 ? void 0 : (_b = _a[0]).toUpperCase) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : '').concat((_h = (_g = (_e = user.lastName) === null || _e === void 0 ? void 0 : (_f = _e[0]).toUpperCase) === null || _g === void 0 ? void 0 : _g.call(_f)) !== null && _h !== void 0 ? _h : '') : 'DU';
}
